'use strict';

var _ = require('underscore');
var ShapewaysView = require('js/lib/views/ShapewaysView');


var SliderView = ShapewaysView.extend({
	
	swAttrs: {
    ROOT: 'data-sw-slider',
    input: 'data-sw-slider-input',
    label: 'data-sw-slider-label',
    min: 'data-sw-slider-min',
    max: 'data-sw-slider-max',
    step: 'data-sw-slider-step'
  },

  initialize: function() {

  	this.cacheElements(this.swSelectors.input, '$input');
    this.cacheElements(this.swSelectors.label, '$label');

  	var min = this.$el.swDataAttr(this.swAttrs.min) || 0;
  	var max = this.$el.swDataAttr(this.swAttrs.max) || 1;
  	var step = this.$el.swDataAttr(this.swAttrs.step) || 0.1;
  	var val;

  	this.hasInput = this.cachedElements.$input.length > 0;

  	if(this.hasInput) {
  		val = this.cachedElements.$input.val();
  		val = _.isEmpty(val) ? min + step : val;
  		val = parseFloat(val);
  		this.setInputVal(val);
  		this.listenToInput();
  	}

  	this.$el.swSlider({
  		change: this.sliderChange.bind(this),
      min: min, 
      max: max, 
      step: step,
      value: val
    });

  },

  setInputVal: function setInputVal(val) {
  	var oldVal;
  	
  	if(!this.hasInput) {
  		return;
  	}

		oldVal = parseFloat(this.cachedElements.$input.val());
		this.cachedElements.$input.val(val);

		if(oldVal !== val) {
			this.cachedElements.$input.trigger('change');
		}
  },

  listenToInput: function listenToInput() {
  	var sliderView = this;
  	if(this.hasInput) {
  		this.cachedElements.$input.on('change', function() {
  			sliderView.$el.swSlider({
  				value: this.cachedElements.$input.val()
  			});
  		});
  	}
  },

  stopListenToInput: function stopListenToInput() {
  	if(this.hasInput) {
  		this.cachedElements.$input.off('change');
  	}
  },

  updateValue: function updateValue(val) {
  	if(this.hasInput) {
  		this.stopListenToInput();
  		this.setInputVal(val);
  		this.listenToInput();
  	}
  },

  sliderChange: function sliderChange(evt, ui) {
		if(!ui || !ui.value) {
			return;
		}
  	this.updateValue(ui.value);
    this.trigger('change', ui.value);
  }

});

module.exports = SliderView;
